import { render } from "./Logo.vue?vue&type=template&id=42da8ca2&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=42da8ca2&scoped=true&lang=css"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42da8ca2"]])

export default __exports__